import { useQuery } from '@tanstack/react-query'
import { postRequest } from 'utils/api/apiRequest'

type Data = {
  id: number
  language: string
  profile: number
  enabled?: boolean
}

export const useGetSubscriberMessageTemplatePreview = ({ id, enabled, ...rest }: Data) => {
  return useQuery({
    enabled: !!id && !!rest?.profile && !!enabled,
    queryKey: ['subscriberMessageTemplatePreview', String(id), JSON.stringify(rest)],
    queryFn: () => postRequest<{ template: string }>(`/subscriber/message-templates/${id}/preview`, rest),
    select: (data) => data?.data,
  })
}
